import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "../analytics"; 

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view whenever the location (URL) changes
    trackPageView(location.pathname);
  }, [location]);

  return null;  // This component doesn't render anything
};

export default Analytics;